/** @jsx jsx */
/* eslint-disable no-use-before-define,no-mixed-operators */
import { jsx } from '@emotion/core'
import React from 'react'
import {css} from '@emotion/core'
import { hideModals, resetModals } from './use-modals'
import { fmt, } from '../twd/twd'

export default ({cusip, issue, initialPrice, currentPrice, pricePrecision, callback} = {}) => {

    const precision = pricePrecision || getPrecision(initialPrice)
    const closeFn = () => {
        if (!callback) {
            hideModals()
            return
        }
        resetModals()
        callback()
    }
    return <React.Fragment>
    <div
        data-name="order-ticket-price-change-notice-modal"
        className="modal-dialog modal-sm">
    <div className="modal-content" >
    <div className="modal-header">
        <button
            className="close"
            aria-label="close"
            data-name="order-ticket-price-change-notice-modal-close-button"
            type="button"
            onClick={closeFn}>
            <i className="material-icons" aria-hidden="true">close</i>
        </button>

        <h2 className="modal-title text-center vertical-offset-sm">Price change notice</h2>

        <div className="row">
        <div className="col-xs-12 col-md-12 text-body">
            <p>The price for the security you are trading has changed since you began the order process.</p>

            <dl css={sectionListCss}>
            <dt>Issuer</dt>
            <dd>{issue || fmt.empty()}</dd>
            <dt>CUSIP</dt>
            <dd>{cusip || fmt.empty()}</dd>
            <dt>Initial price</dt>
            <dd>{formatPrice$(initialPrice, precision)}</dd>
            <dt>Current price</dt>
            <dd>{formatPrice$(currentPrice, precision)}</dd>
            <dt>Change</dt>
            <dd>{formatPrice$(currentPrice - initialPrice, precision)}</dd>
            </dl>
        </div>
        </div>
    </div>


    <div className='modal-footer'>
    <div className="container" style={{background:"#ffffff" }}>

    <div className="row">
    <div className="col-md-12 text-center">
        <button
            className="btn btn-primary-outline"
            aria-label="close"
            data-name="order-ticket-price-change-notice-modal-close-button"
            type="button"
            onClick={closeFn}>
            Close
        </button>
    </div>
    </div>

    </div>
    </div>
    </div>
    </div>

    </React.Fragment>
}

const getPrecision = (a) => {
    return Math.max((((a+'').split('.'))[1] || []).length || 3, 3)
}

const formatPrice$ = (a, n) => {
    n = n || getPrecision(a)
    const x = Number.parseFloat(a)
    if (isNaN(x)) return fmt.empty()

    const p = x<0 ? '-$' : '$'
    return p + Math.abs(x).toLocaleString(
        "en-US",
        {minimumFractionDigits:3, maximumFractionDigits:n})
}


export const sectionListCss = css `
    & {
        display:grid;
        grid-template-columns: 1fr 1fr;
    }
    dt, dd {
        padding: 6px;
        line-height: 1.4;
        font-weight:400;
        border-bottom: 1px solid #e4e4e4;
    }
    dt {
        text-align: left;
        color: #767676;
    }
    dd {
        text-align: right;
        font-weight: 500;
        color: #242424;
    }
`



// WEBPACK FOOTER //
// ./src/order-ticket/price-change-notice-modal.js